import retryCallIfNeeded from '../../../restCalls';

export default function calculatorInputService(client) {
  const calculatorInputUrl = '/api/financialplan/v1/calculatorinput';
  const postCalculatorInput = async payload => retryCallIfNeeded(
    client,
    () => client.post(calculatorInputUrl, payload),
  );
  const getCalculatorInput = async financialPlanId => retryCallIfNeeded(
    client,
    () => client.get(`${calculatorInputUrl}/${encodeURIComponent(financialPlanId)}`),
  );
  const patchCalculatorInput = async (financialPlanId, payload) => retryCallIfNeeded(
    client,
    () => client.patch(`${calculatorInputUrl}/${encodeURIComponent(financialPlanId)}`, payload),
  );

  return {
    postCalculatorInput,
    getCalculatorInput,
    patchCalculatorInput,
  };
}
